import { jsx as _jsx } from "react/jsx-runtime";
import { DragOverlay } from '@dnd-kit/core';
import { useMemo } from 'react';
import { useDraggableList } from './DraggableListContext';
export const Overlay = ({ DragOverlayComponent, dragAction }) => {
    const { dataSource, removeDataSourceItem, updateDataSourceByItem } = useDraggableList();
    const draggedElementData = useMemo(() => dataSource.find((datum) => datum.id === dragAction.elementId), [dataSource, dragAction]);
    return (_jsx(DragOverlay, { children: dragAction && DragOverlayComponent ? (_jsx(DragOverlayComponent, { data: draggedElementData, removeDataSourceItem: removeDataSourceItem, updateDataSourceByItem: updateDataSourceByItem })) : null }));
};
//# sourceMappingURL=Overlay.js.map